import { PureComponent } from 'react';

export type PermissionsWrapperOwnProps = {
  readonly action: string;
  readonly resource: string;
  readonly children?: React.ReactNode;
};

export type PermissionsWrapperStateProps = {
  readonly permission?: boolean;
};

export type PermissionsWrapperProps = PermissionsWrapperOwnProps & PermissionsWrapperStateProps;

export default class PermissionsWrapper extends PureComponent<PermissionsWrapperProps> {
  public override render(): React.ReactNode {
    const { children, permission } = this.props;
    return permission ? children : null;
  }
}
